var toString = require('../to-string');

var upperCase = function upperCase(str) {
  return toString(str).toUpperCase();
};

module.exports = upperCase;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@1.3.1@@antv/util/lib/string/upper-case.js
// module id = 146
// module chunks = 0 1 2